import React, {useEffect} from 'react';

/* Bootstrap */
import {Row, Col, Button, Card} from 'react-bootstrap';

/* Image */
import dog1 from '../img/dog1.png';
import dog2 from '../img/dog2.png';

/* Smooth Scroll */
import { Link } from "react-scroll";

/* Icons */
import { FaPaw, FaVial, FaHome, FaBone, FaClinicMedical, 
	FaCapsules, FaUserMd, FaHeartbeat, FaStethoscope, FaFacebook, 
	FaEnvelope, FaPhone, FaMapMarkedAlt, FaClock } from 'react-icons/fa';

const Main = () => {
	useEffect(() => {
		const L = window.L;
		const mymap = L.map('map').setView([13.155686, 123.7164136], 18);
    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    maxZoom: 18,
    id: 'mapbox/streets-v11',
    tileSize: 512,
    zoomOffset: -1,
		accessToken: process.env.REACT_APP_MAPBOX_KEY
	}).addTo(mymap);
	L.marker([13.1557864, 123.7171373]).addTo(mymap);
	}, [])

	return (
		<>
			<Row className="main">
				<Col md={6} className="left-side">
					<div className="left-container">
						<div className="title">
							<h1>Petfriends Animal Clinic</h1>
							<h2>Your pet's bestfriend.</h2>
						</div>
						<div className="description">
							<p>
								Petfriends is a Veterinary Clinic and Grooming Center located at Binitayan 4501 Daraga, Albay.
							</p>
						</div>
						<div className="action-container">
							<Button href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer" size="lg" className="neu-btn btn-danger">Book now</Button>
							<Link
							to="contact"
							spy={true}
							smooth={true}
							offset={0}
							duration= {800}
							>
								<Button size="lg" variant="outline-danger" className="neu-btn">Contact us</Button>
							</Link>
						</div>
					</div>
				</Col>
				<Col md={6} className="right-side">
					<img className="imgs" src={dog1} alt="dog" load="lazy" />
				</Col>
			</Row>
			<div id="services">
				<div className="text-center services-title">
					<h1>SERVICES</h1>
				</div>
				<div>
					<div className="cards-container">
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaPaw />
								</div>
								<Card.Title>Confinement</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">Duration varies</Card.Subtitle>
								<Card.Text>
									Pet confinement
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaVial />
								</div>
								<Card.Title>Diagnostic Test</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">Duration varies</Card.Subtitle>
								<Card.Text>
									Fecalysis Skin Scraping Rapid Test Kits for Animal Diseases Microscopy Hematology & Blood Chemistry Test Etc..
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaHome />
								</div>
								<Card.Title>Home Service</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">30 minutes and up</Card.Subtitle>
								<Card.Text>
									By appointment
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaBone />
								</div>
								<Card.Title>Grooming & Pet Needs Supplies</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">Duration Varies</Card.Subtitle>
								<Card.Text>
									Grooming Grooming Products Pet Supplies Diapers Milk Dog Foods Cat Foods Etc.
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaClinicMedical />
								</div>
								<Card.Title>Veterinary Pharmacy</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">30 minutes and up</Card.Subtitle>
								<Card.Text>
									Prescription Veterinary Medicines Vitamins Supplements
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaCapsules />
								</div>
								<Card.Title>Deworming</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">Duration varies</Card.Subtitle>
								<Card.Text>
									Pet deworming
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaUserMd />
								</div>
								<Card.Title>Consultation</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">Duration varies</Card.Subtitle>
								<Card.Text>
									Check Up Consultancy (Animal Health Care for Farm)
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaHeartbeat />
								</div>
								<Card.Title>Surgery</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">Duration varies</Card.Subtitle>
								<Card.Text>
									Soft Tissue Surgery Minor & Major
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
						<Card>
							<Card.Body>
								<div className="icon-container">
									<FaStethoscope />
								</div>
								<Card.Title>Vaccination</Card.Title>
								<Card.Subtitle className="mb-2 text-muted">30 minutes and up</Card.Subtitle>
								<Card.Text>
									Anti-Rabies Vaccine DHPPiL for Canines DHPPiL+CCV for Canines Kennel Cough Vaccine for Canines TriCat Vaccine for Felinea
								</Card.Text>
								<div className="card-action">
									<Card.Link href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Make appointment</Card.Link>
								</div>
							</Card.Body>
						</Card>
					</div>
				</div>
			</div>
			<div id="about">
				<div className="about-title">
					<h1>ABOUT</h1>
				</div>
				<Row className="about-content">
					<Col md={6} className="left-side">
						<img className="imgs" src={dog2} alt="dog2" load="lazy" />
					</Col>
					<Col md={6} className="right-side">
						<div className="right-container">
							<h1>PETFRIENDS</h1>
							<p>Petfriends Animal Clinic is your pets bestfriend. Our goal is to provide the best possible veterinary care for your pet. We are very passionate about pets that's why we treat every customer like family and every pet as if they were our own.</p>
							<p>We at Petfriends know that your pet is part of your family, so you can be assured that they are well taken care of when they stay with us.</p>
							<p>We provide a quality medical and surgical care while providing our customers the education and assistance needed in all aspect of animal care and ownership.</p>
							<div className="social-media-container">
								<a href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer"><FaFacebook/><span> Like us on Facebook!</span></a>
							</div>
						</div>
					</Col>
				</Row>
			</div>
			<div id="contact">
				<div className="contact-title">
					<h1>CONTACT</h1>
				</div>
				<div className="contact-content">
					<Row>
						<Col md={6} className="left-side">
							<div id="map"></div>
						</Col>
						<Col md={6} className="right-side">
							<h1>Let's connect</h1>
							<p><FaMapMarkedAlt /><b> Location:</b> Andamar Bldg, Binitayan 4501 Daraga, Albay</p>
							<p><FaPhone /><b> Phone:</b> +639394727735, +639456679200</p>
							<p><FaEnvelope /><b> Email:</b> <a href="mailto:petfriendsanimalclinic2020@gmail.com">petfriendsanimalclinic2020@gmail.com</a></p>
							<p><FaClock /><b> Open hours:</b> Monday - Sunday <b>9:00 AM</b> to <b>5:00 PM</b></p>
							<p><FaFacebook /><b> Facebook Page:</b> Message and like us on facebook <a href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Petfriends Animal Clinic</a></p>
						</Col>
					</Row>
				</div>
			</div>
			<footer>
				<span>&copy; 2020 All rights reserved. <a href="https://facebook.com/petfriendsyourbestfriend" target="_blank" rel="noopener noreferrer">Petfriends Animal Clinic</a> | Created by: <a href="https://justinbalaguer.github.io">JUSTIN BALAGUER</a></span>
			</footer>
		</>
	);
};

export default Main;
